import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import MonetaryAmount from 'common/formatting/MonetaryAmount';
import { typographyCss } from 'common/typography';
import { convertMonetaryIntToDecimal } from 'common/utils/currencyDecimals';
import { useCampaignModuleContext } from 'modules/campaigns/context';

type DeliveryDiscountVariantTextProps = {
  minBasketSize: number | undefined;
};

const Text = styled.div`
  ${typographyCss.Body3};
  font-weight: 700;
`;

const DeliveryDiscountVariantText = ({ minBasketSize }: DeliveryDiscountVariantTextProps) => {
  const { currency } = useCampaignModuleContext();

  return (
    <Text>
      <FormattedMessage
        id={
          !!minBasketSize
            ? 'campaigns.sidebar-preview.free-delivery-banner-preview'
            : 'campaigns.sidebar-preview.free-delivery-short-banner-preview'
        }
        values={
          minBasketSize
            ? {
                minBasketSize: (
                  <MonetaryAmount
                    amount={convertMonetaryIntToDecimal(minBasketSize ?? 0, currency)}
                    currency={currency}
                    numberFormatOptions={{ minimumFractionDigits: 0 }}
                  />
                ),
              }
            : undefined
        }
      />
    </Text>
  );
};

export default DeliveryDiscountVariantText;
